import { rm, NO_ELEMENT } from 'utils';
import cn from 'classnames';
import styles from './styles.scss';

interface TagProps {
  text: string;
  color: string;
  containerClassName?: string;
}

const Tag = ({ text, color, containerClassName }: TagProps) => {
  if (!text || !color) {
    return NO_ELEMENT;
  }

  return (
    <div className={cn(styles.tag, containerClassName, color)}>
      <p>{text}</p>
    </div>
  );
};

export type ProductTags = 'TOP_TESTED' | 'NEW_PRODUCT' | 'MOST_POPULAR_REVIEW';

interface ProductTagProps {
  type: ProductTags;
  containerClassName?: string;
}

type TagOptions = {
  [key in ProductTags]: TagProps;
};

interface ProductTagKey {
  isTopTested?: boolean;
  isNewProduct?: boolean;
}

type TypeProps = { [key in ProductTags]: boolean };

interface GetTypeProps {
  types: TypeProps;
}

const getType = ({ types }: GetTypeProps): ProductTags => {
  const type = Object.entries(types).find(([, shouldDisplay]) => !!shouldDisplay) as [
    ProductTags,
    boolean
  ];

  return type && type[0];
};

export const getProductTagKey = ({ isTopTested, isNewProduct }: ProductTagKey): ProductTags => {
  const types = {
    NEW_PRODUCT: isNewProduct,
    TOP_TESTED: isTopTested
  } as TypeProps;

  return getType({ types });
};

export const ProductTagOptionMap = {
  TOP_TESTED: {
    text: 'product_toptested_title',
    color: styles.top
  },
  NEW_PRODUCT: {
    text: 'product_news_title',
    color: styles.popular
  },
  MOST_POPULAR_REVIEW: {
    text: 'product_review_most_popular_review',
    color: styles.popular
  }
} as TagOptions;

export const ProductTag = ({ type, containerClassName }: ProductTagProps) => {
  if (!type) {
    return NO_ELEMENT;
  }

  const { text, color } = ProductTagOptionMap[type];

  return <Tag containerClassName={containerClassName} text={rm(text)} color={color} />;
};
